import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKey =
	| 'cancelButton'
	| 'cardTitle'
	| 'createButton'
	| 'createSelectedButton'
	| 'folderNameLabel'
	| 'spaceLabel';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
	cancelButton: {
		id: 'conversation-assistant-message-actions.controllers.confluence-folder-create.cancelButton',
		defaultMessage: 'Cancel',
		description: 'Label for the button that declines creating the folder(s).',
	},
	cardTitle: {
		id: 'conversation-assistant-message-actions.controllers.confluence-folder-create.cardTitle',
		defaultMessage: '{count, plural, one {Create folder} other {Create folders}}',
		description:
			'Title of the Confluence create-folder confirmation card in the Rovo chat, pluralized by the number of folders being created.',
	},
	createButton: {
		id: 'conversation-assistant-message-actions.controllers.confluence-folder-create.createButton',
		defaultMessage: 'Create',
		description: 'Label for the button that confirms creating the folder.',
	},
	createSelectedButton: {
		id: 'conversation-assistant-message-actions.controllers.confluence-folder-create.createSelectedButton',
		defaultMessage: 'Create selected',
		description:
			'Label for the button that confirms creating the selected folders when multiple are proposed.',
	},
	folderNameLabel: {
		id: 'conversation-assistant-message-actions.controllers.confluence-folder-create.folderNameLabel',
		defaultMessage: 'Folder name',
		description: 'Label for the name of the folder that will be created.',
	},
	spaceLabel: {
		id: 'conversation-assistant-message-actions.controllers.confluence-folder-create.spaceLabel',
		defaultMessage: 'Space',
		description:
			'Label for the destination space the folder will be created in, shown before the space name.',
	},
});

export default messages;
